import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d81c49d")

_pushScopeId("data-v-1d81c49d")
const _hoisted_1 = { class: "page pa-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h4", { style: {"color":"white","font-weight":"400"} }, "关注设备列表", -1)
const _hoisted_3 = { class: "d-flex items-center" }
const _hoisted_4 = { class: "flex-1" }
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "text-right flex-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "iconfont icon-right" })
], -1)
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "text-right flex-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "iconfont icon-right" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_radio = _resolveComponent("van-radio")
  const _component_router_link = _resolveComponent("router-link")
  const _component_van_radio_group = _resolveComponent("van-radio-group")
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")
  const _component_van_empty = _resolveComponent("van-empty")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    ($setup.list.length)
      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList($setup.list, (item, index) => {
          return (_openBlock(), _createBlock(_component_my_card, {
            key: item.id,
            class: "mt-4"
          }, {
            default: _withId(() => [
              _createVNode(_component_my_card_body, { class: "px-4" }, {
                default: _withId(() => [
                  _createVNode(_component_van_radio_group, {
                    class: "py-4",
                    modelValue: $setup.defaultPush,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ($setup.defaultPush = $event))
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_3, [
                        _createVNode("div", _hoisted_4, _toDisplayString(item.equipmentName), 1),
                        _createVNode("i", {
                          class: "iconfont icon-delete mr-4",
                          style: {"font-size":"18px"},
                          onClick: () => $setup.remove(index)
                        }, null, 8, ["onClick"]),
                        _createVNode(_component_van_radio, {
                          name: item.id,
                          "checked-color": "#5cabd2"
                        }, null, 8, ["name"])
                      ]),
                      (item.leftUser)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: `/report/day/${item.equipmentId}/undefined/0`,
                            class: "mt-4 d-flex items-center link"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", null, [
                                _createVNode("img", {
                                  src: item.leftUser.head || $setup.errorImage,
                                  class: "head"
                                }, null, 8, ["src"])
                              ]),
                              _createVNode("div", _hoisted_5, _toDisplayString(item.leftUser.username), 1),
                              _hoisted_6
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true),
                      (item.rightUser)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: `/report/day/${item.equipmentId}/undefined/1`,
                            class: "mt-4 d-flex items-center link"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", null, [
                                _createVNode("img", {
                                  src: item.rightUser.head || $setup.errorImage,
                                  class: "head"
                                }, null, 8, ["src"])
                              ]),
                              _createVNode("div", _hoisted_7, _toDisplayString(item.rightUser.username), 1),
                              _hoisted_8
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["modelValue"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024))
        }), 128 /* KEYED_FRAGMENT */))
      : ($setup.init)
        ? (_openBlock(), _createBlock(_component_van_empty, {
            key: 1,
            image: "error",
            description: "您还没有关注任何睡眠用户哦"
          }))
        : _createCommentVNode("", true)
  ]))
})